"use client";

import React from "react";
import { Cpu, PhoneCall, FileCheck, Wrench, Rocket, ArrowRight, Activity, Clock, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: "01",
  label: "ADMINISTRATION",
  heading: "General Inquiries",
  description: "contact@studiolegale.it",
  icon: FileCheck,
  align: "left",
  colSpan: "md:col-span-5 md:col-start-2"
}, {
  id: "02",
  label: "PUBLIC RELATIONS",
  heading: "Media Relations",
  description: "press@studiolegale.it",
  icon: PhoneCall,
  align: "right",
  colSpan: "md:col-span-5 md:col-start-7"
}, {
  id: "03",
  label: "LEGAL AFFAIRS",
  heading: "Legal Counsel",
  description: "counsel@studiolegale.it",
  icon: Activity,
  align: "left",
  colSpan: "md:col-span-5 md:col-start-2"
}, {
  id: "04",
  label: "HUMAN RESOURCES",
  heading: "Career Opportunities",
  description: "careers@studiolegale.it",
  icon: Wrench,
  align: "right",
  colSpan: "md:col-span-5 md:col-start-7"
}, {
  id: "05",
  label: "GLOBAL PARTNERSHIPS",
  heading: "International Desk",
  description: "global@studiolegale.it",
  icon: Rocket,
  align: "center",
  colSpan: "md:col-span-8 md:col-start-3"
}];
const protocolFeatures = [{
  title: "Secure Channels",
  description: "End-to-end encrypted communication protocols for all sensitive legal documentation.",
  icon: Clock
}, {
  title: "Priority Response",
  description: "Dedicated desk management ensuring a response within one business cycle.",
  icon: Cpu
}, {
  title: "Global Reach",
  description: "Multilingual correspondence support for our international corporate clientele.",
  icon: TrendingUp
}];
function StepCard({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="159520" data-index={index} ref={ref} className={`
        ${step.colSpan} 
        transition-all duration-1000 ease-out
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}
        ${index > 0 ? 'mt-8 md:mt-24' : ''}
      `}>
      <Card className="bg-card dark:bg-card backdrop-blur-xl border-border/40 shadow-2xl shadow-black/20 overflow-hidden relative group hover:border-primary/50 transition-colors duration-500">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
        
        <CardHeader className="pb-4 relative z-10">
          <div className="flex items-center justify-between mb-4">
            <Badge variant="outline" className="font-mono text-primary border-primary/30 bg-primary/5 tracking-widest">
              DEPT.{step.id}
            </Badge>
            <step.icon className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors duration-300" />
          </div>
          <div className="space-y-1">
            <p className="font-mono text-xs text-muted-foreground tracking-widest uppercase">
              {step.label}
            </p>
            <CardTitle className="text-2xl font-serif font-bold tracking-tight text-foreground">
              {step.heading}
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent className="relative z-10">
          <CardDescription className="font-mono text-sm leading-relaxed text-primary/90 font-medium">
            {step.description}
          </CardDescription>
        </CardContent>
      </Card>
    </div>;
}
export default function HowItWorks() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: protocolRef,
    isVisible: isProtocolVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}